import React, {useState, useEffect} from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import {functions} from 'constants/index';
import ApiServices from 'services/ApiServices';
import LoadingSpinner from 'components/LoadingSpinner';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import CommentIcon from '@material-ui/icons/Comment';
import { useStyles } from "./style";
import { ButtonGroup, IconButton } from '@material-ui/core';
import CustomToolTip from 'components/tooltip';
import { Help } from '@material-ui/icons';

function CheckboxListData() {
  const classes = useStyles(),
    [checked, setChecked] = React.useState([]);
    const ListDeTiposDeCasos = [
        {id: 1, name:'IMAGEN DE FOTOGRAFÍA', description:''},
        {id: 2, name:'IMAGEN DE IMPRESIÓN DACTILAR', description:''},
        {id: 3, name:'IMAGEN DE FIRMA', description:''},
        {id: 4, name:'NOMBRE COMPLETO', description:'Incluye primer nombre, segundo nombre, primer apellido, segundo apellido, apellido casada'},
        {id: 5, name:'DATOS DE LUGAR DE NACIMIENTO', description:'incluye país, departamento y municipio de nacimiento'},
        {id: 6, name:'LUGAR Y/O DIRECCIÓN DE RESIDENCIA DE REFERENCIA RENAP', description:'Departamento y/o municipio de residencia, incluye dirección'},
        {id: 7, name:'DATOS DE LUGAR DE VECINDAD', description:'Departamento y municipio de vecindad'},
        {id: 8, name:'FECHA DE NACIMIENTO', description:''},
        {id: 9, name:'SERIE DEL DPI', description:''},
        {id: 10, name:'FECHA DE EMISIÓN DEL DPI', description:''},
        {id: 11, name:'OTRO', description:''},
    ];

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    // console.log('selectItems: ', newChecked)
    setChecked(newChecked);
  };

  return (
    <List className={classes.root}>
      {ListDeTiposDeCasos.map((value) => {
        const labelId = `checkbox-list-label-${value.id}`;

        return (        
            <ListItem key={value.id} role={undefined} dense button onClick={handleToggle(value.id)}>
                <ListItemIcon className={classes.checkedColor}>
                <Checkbox
                    edge="start"
                    checked={checked.indexOf(value.id) !== -1}
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ 'aria-labelledby': labelId }}
                />
                </ListItemIcon>
                <ListItemText id={labelId} primary={`${value.name}`} />
                { value.description ? 
                    <ListItemSecondaryAction>
                        <ButtonGroup color="primary" aria-label="outlined primary button group">
                            <CustomToolTip title={value.description} ><Help/></CustomToolTip>
                        </ButtonGroup>                        
                    </ListItemSecondaryAction>
                :''}
            </ListItem>                
        );
      })}
    </List>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxListData);